

import { Check } from "lucide-react";
import PricingButton from "../PricingButton";

interface FreePlanCardProps {
  features: string[];
  handleGetStarted: () => void;
}

const FreePlanCard = ({ features, handleGetStarted }: FreePlanCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-md border border-neutral-200 overflow-hidden h-full flex flex-col">
      <div className="p-5 sm:p-6 flex-grow">
        <h3 className="text-lg sm:text-xl font-bold">Free</h3>
        <p className="text-neutral-600 text-xs sm:text-sm mt-1">For personal use</p>
        
        <div className="mt-4 sm:mt-6 mb-2">
          <span className="text-2xl sm:text-3xl font-bold">$0</span>
        </div>
        
        <div className="h-5"></div>
        
        <div className="mt-4 sm:mt-6 mb-3">
          <p className="font-medium text-sm sm:text-base">Included features:</p>
        </div>
        
        <div className="space-y-3">
          {features.map((feature) => (
            <div key={feature} className="flex items-start">
              <div className="flex-shrink-0 mt-0.5">
                <Check className="h-4 w-4 sm:h-5 sm:w-5 text-green-500" />
              </div>
              <p className="ml-2 sm:ml-3 text-sm sm:text-base text-neutral-700">{feature}</p>
            </div>
          ))}
        </div>
        
        <div className="h-10 sm:h-16"></div>
      </div>
      
      <div className="px-5 sm:px-8 pb-5 sm:pb-8">
        <PricingButton onClick={handleGetStarted} variant="default" />
      </div>
    </div>
  );
};

export default FreePlanCard;
